import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useRolePermissionsState } from './useRolePermissionsState';
import type { RolePermissionsContextType } from './types';

const RolePermissionsContext = createContext<RolePermissionsContextType | undefined>(undefined);

export const RolePermissionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { rolePermissions, loading, error, canAccessMenu, canUseFeature, refreshPermissions } = useRolePermissionsState();

  return (
    <RolePermissionsContext.Provider
      value={{
        rolePermissions,
        loading,
        error,
        canAccessMenu,
        canUseFeature,
        refreshPermissions
      }}
    >
      {children}
    </RolePermissionsContext.Provider>
  );
};

export const useRolePermissions = (): RolePermissionsContextType => {
  const context = useContext(RolePermissionsContext);
  if (context === undefined) {
    throw new Error('useRolePermissions must be used within a RolePermissionsProvider');
  }
  return context;
};
